/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Close_LabelInputs */

const en_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close`)
};

const fr_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const de_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const it_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino`)
};

const ru_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрывать`)
};

const es_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca`)
};

const zh_cn2_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭`)
};

const ja_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`近い`)
};

const hi_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बंद करना`)
};

const pt_pt2_work_order_import_close_label = /** @type {(inputs: Work_Order_Import_Close_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar`)
};

/**
* | output |
* | --- |
* | "Close" |
*
* @param {Work_Order_Import_Close_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_close_label = /** @type {((inputs?: Work_Order_Import_Close_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Close_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_import_close_label(inputs)
	if (locale === "de") return de_work_order_import_close_label(inputs)
	if (locale === "it") return it_work_order_import_close_label(inputs)
	if (locale === "ru") return ru_work_order_import_close_label(inputs)
	if (locale === "es") return es_work_order_import_close_label(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_import_close_label(inputs)
	if (locale === "ja") return ja_work_order_import_close_label(inputs)
	if (locale === "hi") return hi_work_order_import_close_label(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_import_close_label(inputs)
	return en_work_order_import_close_label(inputs)
});